<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" lg="10" offset-lg="1">
        <h2>商品一括登録</h2>
      </v-col>
      <v-col>
        <ProductRegistrationForm
          :origin-product-registration="productRegistration"
          :errors="errors"
          :status="status"
          @update-product-registration="productRegistration = value"
          @register-products="registerProducts"
        />
      </v-col>
      <v-col cols="12" lg="10" offset-lg="1">
        <h3 class="subtitle my-3">登録履歴</h3>
        <HistoryTable :product-registrations="productRegistrations" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import HistoryTable from '@/components/commons/productRegistrations/HistoryTable'
import ProductRegistrationForm from '@/components/commons/productRegistrations/Form'
import headUtilsMixin from '@/mixins/head_utils'
import { deserialize } from 'deserialize-json-api'

export default {
  components: {
    HistoryTable,
    ProductRegistrationForm
  },
  filters: {
    moment: function (val) {
      if (val) {
        return moment(val).format('YYYY年M月D日 HH時mm分')
      }
    }
  },
  mixins: [headUtilsMixin],
  data: () => {
    return {
      pageTitle: '商品一括登録',
      productRegistration: {
        csvFile: null,
        zipFile: null
      },
      productRegistrations: [],
      errors: [],
      status: 'yet'
    }
  },
  mounted: function () {
    this.fetchProductRegistrations()
  },
  methods: {
    fetchProductRegistrations () {
      axios.get('/api/product_registrations').then(
        ({ data }) => {
          this.productRegistrations = deserialize(data).data
        },
        (error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.message
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
    },
    registerProducts (productRegistration) {
      this.status = 'registering'
      let formData = new FormData()
      console.log(productRegistration)
      formData.append('zip_file', productRegistration.zipFile)
      formData.append('csv_file', productRegistration.csvFile)
      axios
        .post('/api/product_registrations', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then(
          ({ data }) => {
            const productRegistration = deserialize(data).data
            this.productRegistrations.unshift(productRegistration)
            this.errors = []
            this.status = 'success'
          },
          (error) => {
            this.$store.dispatch('LoaderStore/hideLoader')
            this.errors = error.response.data.message.split(',')
            this.status = 'error'
          }
        )
        .finally(() => {
          this.fetchProductRegistrations()
        })
    }
  }
}
</script>
